import { useEffect, useState } from "react";
import { Trash2, UserPlus, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { Panel } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function Accountants() {
  const { t } = useLang();
  const [rows, setRows] = useState([]);
  const [f, setF] = useState({ email: "", name: "", password: "" });
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/accountants").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post("/accountants", f); toast.success(t("accountantInvited")); setF({ email: "", name: "", password: "" }); load(); } catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
  };
  const revoke = async (r) => { if (!window.confirm(t("confirmDelete"))) return; try { await api.delete(`/accountants/${r.id}`); load(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <Panel className="mt-6 max-w-3xl p-6" data-testid="accountants-panel">
      <h3 className="font-display text-lg font-bold">{t("accountantAccess")}</h3>
      <p className="mt-1 text-sm text-slate-500">{t("accountantAccessText")}</p>
      <ul className="mt-4 divide-y divide-slate-100">
        {rows.map((r) => (
          <li key={r.id} data-testid={`accountant-row-${r.id}`} className="flex items-center justify-between gap-3 py-2 text-sm">
            <div><span className="font-semibold">{r.name || r.email}</span> <span className="text-slate-500">{r.name && `· ${r.email}`}</span></div>
            <button data-testid={`accountant-revoke-${r.id}`} onClick={() => revoke(r)} className="rounded p-1.5 text-slate-500 hover:bg-red-50 hover:text-[#CE1126]"><Trash2 className="h-4 w-4" /></button>
          </li>
        ))}
      </ul>
      {rows.length < 3 && (
        <form onSubmit={submit} className="mt-4 grid gap-2 sm:grid-cols-[1fr_1fr_1fr_auto]">
          <Input data-testid="accountant-name-input" placeholder={t("fullName")} value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} />
          <Input data-testid="accountant-email-input" type="email" required placeholder={t("email")} value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} />
          <Input data-testid="accountant-password-input" type="text" required minLength={8} placeholder={t("tempPassword")} value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} />
          <Button data-testid="accountant-invite-btn" disabled={busy} className="bg-[#007A3D] hover:bg-[#005E2E]">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <UserPlus className="me-1 h-4 w-4" />}{t("invite")}</Button>
        </form>
      )}
    </Panel>
  );
}
